import React from "react";
import "./_home.scss";
import UsageGuide from "./usage-guide/UsageGuide";
import Help from "./help/Help";
import Viewer from "./viewer/Viewer";
import ViewingOptions from "./viewing-options/ViewingOptions";
import useHomeController from "./use-home.controller";
import { ReactComponent as TemperatureIcon } from "../../../assets/icons/temperature-half-icon.svg";
import { ReactComponent as WindowIcon } from "../../../assets/icons/window-tint-icon.svg";
import { ReactComponent as SunIcon } from "../../../assets/icons/sun-icon.svg";
import "./_home.scss";

const Home = () => {
  const {
    playerAssetsConfig: { baseUrl, ...paths },
    handlePlayerLoadInit,
    playerActions,
  } = useHomeController();

  return (
    <>
      <Help />
      <UsageGuide />
      <div className="home">
        <div className="home-viewer__maincontent-wrapper">
          <Viewer
            loaderConfig={{
              // @ts-ignore
              loaderUrl: baseUrl + paths?.loaderUrl,
              // @ts-ignore
              dataUrl: baseUrl + paths?.dataUrl,
              // @ts-ignore
              frameworkUrl: baseUrl + paths?.frameworkUrl,
              // @ts-ignore
              codeUrl: baseUrl + paths?.codeUrl,
              // @ts-ignore
              streamingAssetsUrl: baseUrl + paths?.streamingAssetsUrl,
              companyName: "Avant Leap",
              productName: "IoT Model Viewer",
              productVersion: "0.0.1",
            }}
            onLoadSuccessCallback={handlePlayerLoadInit}
          />
        </div>

        <ViewingOptions
          viewingOptionItems={[
            {
              itemKey: "GET_GLASS_PANELS_POLARIZATION",
              icon: <WindowIcon className="window-icon" />,
              content: "Panels Polarization",
              messageAction: playerActions.setGlassPanelsPolarizationFeature,
            },
            {
              itemKey: "GET_TINT_STATUS",
              icon: <SunIcon className="window-icon" />,
              content: "Tint Status",
              messageAction: playerActions.setGlassPanelsTintStatusFeature,
            },
            {
              itemKey: "GENERATE_HEATMAP",
              icon: <TemperatureIcon />,
              content: "Generate Heatmap",
              messageAction: playerActions.setHeatMapFeature,
            },
          ]}
        />
      </div>
    </>
  );
};

export default Home;
